import { useAppStore } from '@src/shared/zustand/store';

export const addToHistory = (path: string) =>
  useAppStore.setState((state) => ({
    history: [...state.history, path],
  }));

export const removeFromHistory = (path: string) => {
  const state = useAppStore.getState();
  const length = state.history.filter((item) => item === path)?.length;

  useAppStore.setState({
    history: state.history.filter((item) => item !== path),
  });

  return length;
};
